
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageBeforeIn: function () {
      //console.log("pageBeforeIn");
      var self = this;
      self.$setState({
        user: window.identity
      }, function () {});
    }
  },
  data: function () {
    return {
      user: null,
      //window.identity
      versionLabel: window.appVersionLabel,
      buildNumber: window.buildNumber
    };
  },
  beforeMount: function () {
    var self = this;
    var app = self.$app;
    var $$ = self.$dom7; //Get profile

    $$(".view-account").once("tab:show", function () {
      self.loadProfile();
    });
  },
  methods: {
    updateNotification: function () {
      var self = this;
      var app = self.$app;
      var formData = self.$app.form.convertToData("#notification-settings-form");
      Object.keys(formData).forEach(function (key, value) {
        formData[key] = formData[key][0] ? 1 : 0;
      }); //console.log(formData);

      self.$app.request({
        url: Url.to("user/notification"),
        method: "POST",
        data: formData,
        preloader: false,
        progress: true,
        success: function (data, status, xhr) {
          //console.log(data, status, xhr);
          User.logIn(data);
        }
      });
    },
    loadProfile: function () {
      var self = this;
      var app = self.$app;
      app.request({
        url: Url.to("user/profile"),
        preloader: false,
        progress: true,
        success: function (data, status, xhr) {
          //console.log(">>>>>>>>>", data);
          User.logIn(data);
          self.$setState({
            user: data
          }, function () {});
        }
      });
    },
    checkForUpdate: function () {
      var self = this;
      self.$app.request({
        url: Url.to("data/check-update"),
        preloader: true,
        progress: false,
        data: {
          version: window.appVersionLabel,
          platform: self.$app.device.os
        },
        success: function (data, status, xhr) {
          //console.log(">>>>>>>>>", data);
          if (data['update']) {
            self.$app.dialog.confirm('A new version is available to download. Would you like to update now?', function () {
              window.open(data['link'], '_system');
            });
          } else {
            self.$app.dialog.alert('You already have the latest version.', function () {});
          }
        }
      });
    },
    logout: function () {
      var self = this;
      self.$app.dialog.confirm('Are you sure you want to log out?', function () {
        self.$app.request({
          url: Url.to("user/logout"),
          preloader: true,
          progress: false,
          data: {},
          complete: function (data, status, xhr) {
            if (window.navigator && window.navigator.splashscreen) {
              window.navigator.splashscreen.show();
            }

            setTimeout(function () {
              User.logOut();
              window.location.reload();
            }, 250);
          }
        });
      });
    }
  },
  id: '398b32f033',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar" data-name="account">\n        <!-- Top Navbar -->\n        <div class="navbar navbar-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner">\n                <div class="left">\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title sliding">Account</div>\n                <div class="right"></div>\n                <div class="title-large">\n                    <div class="title-large-text">Account</div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content">\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="list media-list profile-list no-hairlines">\n                <ul>\n                    <li>\n                        <a href="/edit-profile/" class="item-link item-content">\n                            <div class="item-media">\n                                <img src="';
          r += c(ctx_2.user.image_thumb_url, ctx_2);
          r += '" width="60"/>\n                            </div>\n                            <div class="item-inner">\n                                <div class="item-title-row primary-after padding-right">\n                                    <div class="item-title">';
          r += c(ctx_2.user.name, ctx_2);
          r += '</div>\n                                    <div class="item-after text-color-primary">Update</div>\n                                </div>\n                                <div class="item-subtitle">Tap here to update your profile</div>\n                            </div>\n                        </a>\n                    </li>\n                </ul>\n            </div>\n\n            <div class="block-title display-none">Notifications</div>\n            <div class="list simple-list display-none" id="notification-settings-form">\n                <ul>\n                    <li>\n                        <span>Allow notifications</span>\n                        <label class="toggle toggle-init">\n                            <input @change="updateNotification" type="checkbox" name="enable_notification" value="1" ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.user.enable_notification, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'checked';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '>\n                                    <span class="toggle-icon"></span>\n                        </label>\n                    </li>\n                    <li class="display-none">\n                        <span>Contracts reminders</span>\n                        <label class="toggle toggle-init">\n                            <input @change="updateNotification" type="checkbox" name="contracts_reminders" value="1" ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.user.contracts_reminders, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'checked';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '>\n                                    <span class="toggle-icon"></span>\n                        </label>\n                    </li>\n                    <li class="display-none">\n                        <span>Maintenance notifications</span>\n                        <label class="toggle toggle-init">\n                            <input @change="updateNotification" type="checkbox" name="maintenance_notifications" value="1" ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.user.maintenance_notifications, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'checked';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '>\n                                    <span class="toggle-icon"></span>\n                        </label>\n                    </li>\n                    <li class="display-none">\n                        <span>News and promotions</span>\n                        <label class="toggle toggle-init">\n                            <input @change="updateNotification" type="checkbox" name="news_notifications" value="1" ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.user.news_notifications, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'checked';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '>\n                                    <span class="toggle-icon"></span>\n                        </label>\n                    </li>\n                </ul>\n            </div>\n\n\n            <div class="block-title">Consent</div>\n            <div class="list links-list-custom">\n                <ul>\n                    <li>\n                        <a href="/manage-consent/" class="item-link">\n                            <div class="item-content">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Manage Consent\n                                    </div>\n                                </div>\n                            </div>\n                        </a>\n                    </li>\n                </ul>\n            </div>\n\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="preloader infinite-scroll-preloader"></div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <div class="block-title">Others</div>\n            <div class="list links-list-custom">\n                <ul>\n                    <li class="hide-webapp">\n                        <a href="#" class="item-link"  @click="checkForUpdate">\n                            <div class="item-content">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Check for updates\n                                    </div>\n                                    <div class="item-after">\n                                        V';
      r += c(ctx_1.versionLabel, ctx_1);
      r += ' B:';
      r += c(ctx_1.buildNumber, ctx_1);
      r += '\n                                    </div>\n                                </div>\n                            </div>\n                        </a>\n                    </li>\n                    <li>\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <a href="mailto:';
          r += c(ctx_2.$root.email, ctx_2);
          r += '?subject=Bug report [';
          r += c(ctx_2.user.name, ctx_2);
          r += '][';
          r += c(ctx_2.user.id, ctx_2);
          r += '][';
          r += c(ctx_2.$root.country, ctx_2);
          r += ']" target="_system" class="item-link external">\n                            <div class="item-content">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Report a bug\n                                    </div>\n                                </div>\n                            </div>\n                        </a>\n                        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </li>\n                    <li>\n                        <a href="#" class="item-link" @click="logout">\n                            <div class="item-content">\n                                <div class="item-inner">\n                                    <div class="item-title">\n                                        Logout\n                                    </div>\n                                </div>\n                            </div>\n                        </a>\n                    </li>\n                </ul>\n            </div>\n\n            <div class="block-title">Follow us</div>\n            <div class="block">\n                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.facebook.com/mitsuliftgroup">\n                    <i class="icon f7-icons" style="font-size: 40px;">logo_facebook</i>\n                </a>\n                &nbsp;\n                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.linkedin.com/company/mitsulift-group/">\n                    <i class="icon f7-icons" style="font-size: 40px;">logo_linkedin</i>\n                </a>\n                &nbsp;\n                <a class="link icon-only no-margin-left text-color-gray external" target="_system" href="https://www.instagram.com/mitsuliftgroup/">\n                    <i class="icon f7-icons" style="font-size: 40px;">logo_instagram</i>\n                </a>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    